import React from 'react';
import { VStack, Text } from '@chakra-ui/react';

import ClassComponent from '../../components/ClassComponent';
import Loader from '../../../../components/Loader';
import ClassPage from '../Class';
import {
  useDashboardGlobalProgramsQuery,
  // useTrackLazyQuery,
} from '../../../../generated/graphqlModels';
import { useTranslation } from 'react-i18next';

// const LOAD_INCREMENT = 10;

interface SelfLearningProps {
  user: any;
}

const SelfLearning: React.FC<SelfLearningProps> = (props) => {
  const { user } = props;
  const { t } = useTranslation();
  // const [loadCountGlobalProgams, setLoadCountGlobalProgams] =
  //   useState<number>(LOAD_INCREMENT);

  const { data, loading, error } = useDashboardGlobalProgramsQuery({
    variables: {
      enrolledOrTeacher: user?.flags.includes('only-related-classes'),
    },
    skip: user == null || user.pk == null,
  });

  return (
    <VStack
      align="start"
      gap="4"
      w="full"
      borderTop="1px solid #E0E0E0"
      marginTop="20px"
      paddingTop="20px"
    >
      <Text as="h4" textStyle="h4">
        {t('section.selfLearning')}
      </Text>
      {loading && <Loader />}
      <VStack gap="2" w="full" align="start">
        {data &&
          data.globalStudyGroups &&
          // @ts-ignore
          data.globalStudyGroups?.map((studyGroup, index) => (
            <ClassComponent
              key={studyGroup.id}
              to={ClassPage.getRoute(
                studyGroup.license.program.id,
                'units',
                `?study-group-id=${studyGroup.id}&is_self_learning=true`,
              )}
              {...studyGroup.license.program}
              name={`${studyGroup.license.program.name} - ${studyGroup.name}`}
              enabled={user['pages']['study_group']}
              sameHeight={false}
              showInfo={index === 0}
            />
          ))}
        {!loading && data?.globalStudyGroups.length === 0 && (
          <Text>{t('selfLearningPage.noSelfLearningPrograms')}</Text>
        )}
        {!loading && error != null && (
          <Text>{t('selfLearningPage.errorLoadingSelfLearningClasses')}</Text>
        )}
      </VStack>
    </VStack>
  );
};

export default SelfLearning;
export { SelfLearning };
